import { ContactType } from "model/contact.model";

/** ---- Dispatch Types ---- */
export const CONTACT_CREATED_ERROR = "CONTACT_CREATED_ERROR";
export const CONTACT_CREATED = "CONTACT_CREATED";
export const CONTACT_CURRENT = "CONTACT_CURRENT";
export const CONTACT_CREATE_START = "CONTACT_CREATE_START";
export const CONTACT_UPDATE = "CONTACT_UPDATE";
export const CONTACT_UPDATE_START = "CONTACT_UPDATE_START";

/** ---- Dispatch Interfaces ---- */
interface ContactCreated {
  type: typeof CONTACT_CREATED;
  payload: ContactType;
}

interface ContactCurrent {
  type: typeof CONTACT_CURRENT;
  payload: ContactType;
}

interface ContactUpdatedStart {
  type: typeof CONTACT_UPDATE_START;
  payload: ContactType;
}

interface ContactUpdated {
  type: typeof CONTACT_UPDATE;
  payload: ContactType;
}

interface ContactCreatedError {
  type: typeof CONTACT_CREATED_ERROR;
}

interface ContactCreateStart {
  type: typeof CONTACT_CREATE_START;
}

export type ContactAction =
  | ContactCreateStart
  | ContactCreated
  | ContactCurrent
  | ContactCreatedError
  | ContactUpdatedStart
  | ContactUpdated;
